import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Property } from 'src/app/models/properties/property.model';
import { PropertyTypes } from 'src/app/models/properties/types.model';
import { BaseService } from '../base/base.service';
import { Languages } from './../../models/properties/languages.model';

@Injectable({
  providedIn: 'root'
})
export class PropertyService extends BaseService<Property> {
  constructor(protected http: HttpClient) {
    super(http, 'configs');
  }

  propertyTypes(): Observable<HttpResponse<PropertyTypes>> {
    return this.http.get<PropertyTypes>(`${this.resourceUrl}/types`, {
      observe: 'response'
    });
  }

  languages(): Observable<HttpResponse<Languages>> {
    return this.http.get<Languages>(`${this.resourceUrl}/languages`, {
      observe: 'response'
    });
  }

  updateProperty(
    id: number,
    entity: Property
  ): Observable<HttpResponse<Property>> {
    return this.http.put<Property>(`${this.resourceUrl}/${id}`, entity, {
      observe: 'response'
    });
  }
}
